import React from "react";

export class Required extends React.PureComponent {
    render() {
        return <span className="text-danger">*</span>;
    }
}
